import { takeLatest, select, put } from 'redux-saga/effects';
import { consts as repliesActions } from '../../board/replies';
import { chatModuleInstanceSelector } from '../selectors';
import chatConsts from '../constants';

function* sendMessageWorker(action) {
  const state = yield select();
  const chatModuleInstance = chatModuleInstanceSelector(state);
  const {
    channelId,
    important,
    message,
    quoteMessageId,
    linkPayload,
    inboxTaskId,
  } = action.payload;

  chatModuleInstance.getCircle(channelId).sendMessage({
    message,
    important,
    quoteMessageId,
    linkPayload,
    inboxTaskId,
  });

  if (quoteMessageId) {
    yield put({
      type: repliesActions.REMOVE_ITEM,
      payload: channelId,
    });
  }
}

export default function* sendMessageSaga() {
  yield takeLatest([chatConsts.SEND_MESSAGE], sendMessageWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/sendMessage.js